import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GetAllBuyersRequestDto } from "../models/orders/getAllBuyersRequestDto";
import { GetAllBuyersResponseDto } from "../models/orders/getAllBuyersResponseDto";
import { GenericResponseDto } from "../models/generic-response.dto";
import { Address } from "../models/shared/address";
import { ClientSearchList } from "../models/shared/clientSearchList";

@Injectable({
  providedIn: "root",
})
export class BuyerService {
  private clientManagementBaseURL = environment.baseUrl + "/clientmanagement";
  private commanBaseURL = environment.baseUrl + "/Common";
  constructor(private _http: HttpClient) {}

  getAllBuyers(
    request: GetAllBuyersRequestDto
  ): Observable<GenericResponseDto<GetAllBuyersResponseDto[]>> {
    return this._http.post<GenericResponseDto<GetAllBuyersResponseDto[]>>(
      this.clientManagementBaseURL + `/GetAllBuyers`,
      request
    );
  }

  getCustomerAddressByPartyNumber(
    partyNumber = "",
    accountNumber = ""
  ): Observable<GenericResponseDto<Address[]>> {
    return this._http.get<GenericResponseDto<Address[]>>(
      this.commanBaseURL +
        `/GetAddressesByPartyNumberAndAccountNumber?partyNumber=${partyNumber}&accountNumber=${accountNumber}`
    );
  }

  getCustomerByNameAndAccountNumberFilter(
    customerAccountNumber = "",
    moduleName = ""
  ): Observable<GenericResponseDto<ClientSearchList[]>> {
    return this._http.get<GenericResponseDto<ClientSearchList[]>>(
      this.clientManagementBaseURL +
        `/SearchClientByNameOrAccountNumber?nameAccounNumber=${encodeURIComponent(
          customerAccountNumber
        )}&moduleName=${moduleName}`
    );
  }
}
